import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalService } from "@app/services/global.service";
import { AuthenticationService } from "@app/services";

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService {

  private requests: HttpRequest<any>[] = [];

  constructor(private global: GlobalService,
    private authenticationService: AuthenticationService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.global.setMainLoading(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // X-Skip-Loading solo omite el indicador de carga — nunca omite errores ni 401
    let skipLoading = req.headers.has('X-Skip-Loading');
    let cleanReq = skipLoading
      ? req.clone({ headers: req.headers.delete('X-Skip-Loading') })
      : req;

    if (!skipLoading) {
      this.requests.push(cleanReq);
      this.global.setMainLoading(true);
    }

    return new Observable((observer) => {
      const subscription = next.handle(cleanReq)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              if (!skipLoading) this.removeRequest(cleanReq);
              observer.next(event);
            }
          },
          err => {
            console.error(err);
            if (!skipLoading) this.removeRequest(cleanReq);
            if (err.status === 401) {
              this.authenticationService.logout();
              this.authenticationService.resetUser();
              if (!window.location.href.includes("login")) {
                location.reload();
              }
            } else {
              this.global.prepareAlert({
                title: "Error HTTP",
                message: err.message,
                label: "error"
              }).subscribe(() => {
                observer.error(err);
              });
            }
          },
          () => {
            if (!skipLoading) this.removeRequest(cleanReq);
            observer.complete();
          });
      return () => {
        if (!skipLoading) this.removeRequest(cleanReq);
        subscription.unsubscribe();
      };
    });
  }
}

